import React, { useState } from "react";
import { Grid } from "@mui/material";

import { useTranslation } from "react-i18next";
import Survey from "./Survey";
import Completed from "./Completed";
import HeaderImage from "../components/HeaderImage";
import Header from "../components/Header";
import { SURVEY_IDS } from "../utils/constants";

const Clio6 = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const { t } = useTranslation();

  {
    document.title = " CLIO 6 ";
  }

  const surveyId = SURVEY_IDS.CLIO6;

  return (
    <Grid container>
      <Header model={"clio6"} />
      <HeaderImage model={"clio6"} />

      {isCompleted ? <Completed /> : <Survey setIsCompleted={setIsCompleted} surveyId={surveyId} />}
    </Grid>
  );
};

export default Clio6;
